import { faAddressCard, faCreditCard, faHandshake } from '@fortawesome/free-regular-svg-icons';

export default [faAddressCard, faCreditCard, faHandshake];
